import React from "react";
import SnackbarContent from "@mui/material/SnackbarContent";
import { withStyles } from "@mui/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import {green} from "@mui/material/colors";
import {amber} from "@mui/material/colors";
import classNames from "classnames";

const styles = (theme) => ({
  success: {
    backgroundColor: green[600] + " !important",
  },
  error: {
    backgroundColor: theme.palette.error.dark + " !important",
  },
  info: {
    backgroundColor: theme.palette.primary.dark + " !important",
  },
  warning: {
    backgroundColor: amber[700] + " !important",
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
});

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const CustomSnackbarContent = React.forwardRef((props, ref) => {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
      <SnackbarContent
          ref={ref} // <-- Ensure ref is passed to SnackbarContent
          className={classNames(classes[variant], className)}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
              {message}
        </span>
          }
          {...other}
      />
  );
});

export default withStyles(styles)(CustomSnackbarContent);